'use client';

/**
 * ProjectTabs
 *
 * Tab navigation component for project detail page.
 * Uses URL query parameters to track active tab.
 */

import { Tabs, TabsList, TabsTrigger } from '@cortex/ui';
import { useNavigate } from '@tanstack/react-router';
import { FileCode2, Key, Link2, Settings } from 'lucide-react';

interface ProjectTabsProps {
  projectId: string;
  activeTab: string;
}

export function ProjectTabs({ projectId, activeTab }: ProjectTabsProps) {
  const navigate = useNavigate();

  const handleTabChange = (tabId: string) => {
    void navigate({
      to: '/admin/projects/$id',
      params: { id: projectId },
      search: { tab: tabId },
    });
  };

  return (
    <Tabs value={activeTab} onValueChange={handleTabChange}>
      <TabsList variant="underline">
        <TabsTrigger value="details" variant="underline" icon={Settings}>
          Details
        </TabsTrigger>
        <TabsTrigger value="configuration" variant="underline" icon={FileCode2}>
          Configuration
        </TabsTrigger>
        <TabsTrigger value="connections" variant="underline" icon={Link2}>
          Connections
        </TabsTrigger>
        <TabsTrigger value="environment" variant="underline" icon={Key}>
          Environment
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
